import { CustomerProfile, CustomerProfiles, IndicatorConfig } from '../../tenants/types';

/**
 * Perfiles por aseguradora (`TenantConfig.customers`): funciones puras que combinan el config del tenant con lo que
 * pisa el perfil del `customer` activo (`CustomerContext.customerId`). Sin mapa, sin customer o con un customer
 * desconocido, todo queda como define el tenant. Los componentes nunca preguntan por un id de customer: aplican estos
 * resolvers.
 */

/** Perfil de la aseguradora, o `null` (sin customer, sin mapa o customer desconocido). El id `0` es válido. */
export const customerProfile = (
    customers: CustomerProfiles | undefined,
    customerId: number | null | undefined
): CustomerProfile | null => {
    if (customerId === null || customerId === undefined || !customers) {
        return null;
    }
    return customers[customerId] || null;
};

/** `true` si algún perfil cambia la página de item: entonces la página espera a conocer la aseguradora. */
export const hasItemPageOverrides = (customers: CustomerProfiles | undefined): boolean =>
    !!customers && Object.values(customers).some(profile => !!(profile.pages && profile.pages.item));

/**
 * Indicadores de la página de item (`pages.item.indicators`) para una aseguradora: los del tenant, en su orden, sin
 * los `pages.item.hiddenIndicators` del perfil. No muta el array del tenant.
 */
export const resolveItemIndicators = (
    indicators: IndicatorConfig[],
    customers: CustomerProfiles | undefined,
    customerId: number | null | undefined
): IndicatorConfig[] => {
    const profile = customerProfile(customers, customerId);
    const hidden = (profile && profile.pages && profile.pages.item && profile.pages.item.hiddenIndicators) || [];
    return indicators.filter(indicator => !hidden.includes(indicator.key));
};
